/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPLANGUAGE = {
    EnglishIreland: '6153',
    EnglishUs: '1033',
    Spanish: '10',
    Swedish: '4',
    French: '12',
    Flemish: '7',
    German: '8',
    Norwegian: '1044',
    Afrikaans: '13'
} as const;
export type IAPLANGUAGE = typeof IAPLANGUAGE[keyof typeof IAPLANGUAGE];


export function IAPLANGUAGEFromJSON(json: any): IAPLANGUAGE {
    return IAPLANGUAGEFromJSONTyped(json, false);
}

export function IAPLANGUAGEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPLANGUAGE {
    return json as IAPLANGUAGE;
}

export function IAPLANGUAGEToJSON(value?: IAPLANGUAGE | null): any {
    return value as any;
}

